import { createSlice } from '@reduxjs/toolkit'
import {
  addCoutSupplementaire,
  deleteCoutSupplementaire,
  getCoutSupplementairebyId,
  getCoutSupplementairesByActionId,
  updateCoutSupplementaire,
} from './coutSupplementaireAction'
import {
  CoutSupplementaire,
  CoutSupplementaireResponse,
} from '../../types/coutSupplementaireTypes'

interface CoutSupplementaireState {
  coutSupplementaires: CoutSupplementaire[]
  loading: boolean
  coutSupplementaire: CoutSupplementaire | null
  error: string | null
  addedCoutSupplementaire: CoutSupplementaire | null
  updatedCoutSupplementaire: CoutSupplementaire | null
  CoutSupplementaireResponse: CoutSupplementaireResponse | null
}

const initialState: CoutSupplementaireState = {
  coutSupplementaires: [],
  loading: false,
  error: null,
  addedCoutSupplementaire: null,
  coutSupplementaire: null,
  updatedCoutSupplementaire: null,
  CoutSupplementaireResponse: null,
}

export const coutSupplementaireSlice = createSlice({
  name: 'coutSupplementaire',
  initialState,
  reducers: {
    clearCoutSupplementaireError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCoutSupplementaire.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteCoutSupplementaire.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        const deletedCoutSupplementaireId = action.meta.arg

        if (state.coutSupplementaires) {
          state.coutSupplementaires = (state.coutSupplementaires ?? []).filter(
            (coutSupplementaire) =>
              coutSupplementaire._id !== deletedCoutSupplementaireId
          )
        }
      })
      .addCase(deleteCoutSupplementaire.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
      .addCase(addCoutSupplementaire.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addCoutSupplementaire.fulfilled, (state, action) => {
        state.loading = false
         state.error = null
        state.addedCoutSupplementaire = action.payload
        if (Array.isArray(state.coutSupplementaires)) {
          state.coutSupplementaires.push(action.payload)
        } else {
          state.coutSupplementaires = [action.payload]
        }
      })
      .addCase(addCoutSupplementaire.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
      .addCase(updateCoutSupplementaire.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateCoutSupplementaire.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        state.updatedCoutSupplementaire = action.payload
      })
      .addCase(updateCoutSupplementaire.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
      .addCase(getCoutSupplementairebyId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCoutSupplementairebyId.fulfilled, (state, action) => {
        state.loading = false
        state.coutSupplementaire = action.payload
      })
      .addCase(getCoutSupplementairebyId.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
      .addCase(getCoutSupplementairesByActionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCoutSupplementairesByActionId.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        const activitiesCoutSupp = Object.values(action.payload).filter(
          (item) => item && typeof item === 'object'
        )
        state.coutSupplementaires = activitiesCoutSupp as []
      })
      .addCase(getCoutSupplementairesByActionId.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
  },
})

export const { clearCoutSupplementaireError } = coutSupplementaireSlice.actions

export default coutSupplementaireSlice.reducer
